import React from "react";
import AppRouter from "./routers/AppRouter";

export const RegistroApp = () => {
  return (
    <div>
      <AppRouter />
    </div>
  );
};
